import PropTypes from 'prop-types';


const serviceProviderDraftShape = {
  '@id':       PropTypes.string.isRequired,
  '@type':     PropTypes.string.isRequired,
  name:        PropTypes.string.isRequired,
  description: PropTypes.string,
  email:       PropTypes.string,
  telephone:   PropTypes.string,
  logo:        PropTypes.string,
};


const serviceProviderDraftPropType = PropTypes.shape(serviceProviderDraftShape);


export { serviceProviderDraftPropType, serviceProviderDraftShape };



// WEBPACK FOOTER //
// ./src/domain/serviceProviderDraft.js